import { Cell } from '../grid/Cell'
import { BaseModal } from './BaseModal'

type Props = {
  isOpen: boolean
  handleClose: () => void
}

export const InfoModal = ({ isOpen, handleClose }: Props) => {
  return (
    <BaseModal title="So funktioniert's:" isOpen={isOpen} handleClose={handleClose}>
      <p className="text-base text-gray-500 dark:text-gray-300">
         Errate das Wort des Tages in 6 Versuchen, dabi variiren die Wörter täglich zwischen 4 - 9 Buchstaben. Nach jedem Versuch wird dir mit Farben angezeigt, wie nah dein Wort an der Lösung war.
      </p>
      <p className="mt-4 text-base text-gray-500 dark:text-gray-300 font-bold">
         Hinweis:
      </p>
      <p className="text-base text-gray-500 dark:text-gray-300">
         Die Umlaute Ä, Ö und Ü werden durch AE, OE und UE ersetzt, und ß durch SS. Unter den normalen Wörtern sind unter anderem auch Spiele die Curry gespielt hat oder Insider aus dem Stream.
      </p>
      <p className="mt-4 text-base text-gray-500 dark:text-gray-300 font-bold">
         Beispiel:
      </p>
      <p className="text-base text-gray-500 dark:text-gray-300">
         Das gesuchte Wort ist WURST. Das eingegebene Wort ist ASIAT.
      </p>
      <div className="flex justify-center mb-1 mt-4">
        <Cell value="W" />
        <Cell value="U" />
        <Cell value="R" />
        <Cell value="S" />
        <Cell value="T" />
      </div>
      <div className="flex justify-center mb-1 mt-4">
        <Cell
          isRevealing={true}
          isCompleted={true}
          value="A"
          status="absent"
        />
        <Cell
          isRevealing={true}
          isCompleted={true}
          value="S"
          status="present"
        />
        <Cell
          isRevealing={true}
          isCompleted={true}
          value="I"
          status="absent"
        />
        <Cell
          isRevealing={true}
          isCompleted={true}
          value="A"
          status="absent"
        />
        <Cell
          isRevealing={true}
          isCompleted={true}
          value="T"
          status="correct"
        />
      </div>
      <p className="text-base text-gray-500 dark:text-gray-300">
         Das T kommt im Wort an der richtigen Stelle vor.
      </p>
      <p className="text-base text-gray-500 dark:text-gray-300">
         Das S kommt im Wort vor, jedoch an anderer Stelle.
      </p>
      <p className="text-base text-gray-500 dark:text-gray-300">
        Das A und I kommen nicht im Wort vor.
      </p>

      <p className="mt-4 text-base text-gray-500 dark:text-gray-300 font-bold">
         Jeden Tag um Mitternacht wird ein neues Wort des Wurst-Wahnsinn freigeschaltet.
      </p>

      <p className="mt-6 italic text-sm text-gray-500 dark:text-gray-300">
        WURSTL ist ein deutschsprachiger Klon von{' '}
        <a
          href="https://www.powerlanguage.co.uk/wordle/"
          className="underline font-bold"
        >
          Wordle
        </a>
        . Den Source Code findet ihr{' '}
        <a
          href="https://github.com/cwackerfuss/react-wordle"
          className="underline font-bold"
        >
          auf Github
        </a>
        .
      </p>

      <p className="mt-6 italic text-sm text-gray-500 dark:text-gray-300">
         &copy;letsi - 2022 | Version: 1.0.3
      </p>
    </BaseModal>
  )
}
